import type { BlotterPanelTabType } from 'components/shared/Blotter/BlotterPanel/BlotterPanelHeader/BlotterPanelHeader';
import type { BlotterType } from 'models/blotters/BlotterType';
import type { IBlotterItem } from 'models/IBlotterItem';
import { createContext } from 'react';

export interface BlotterPanelContextProps {
  activeTab?: BlotterPanelTabType;
  blotterType: BlotterType;
  blotterItem?: IBlotterItem;
  setActiveTab: (tab: BlotterPanelTabType) => void;
}

export const BlotterPanelContext = createContext<BlotterPanelContextProps | undefined>(undefined);
